
import './App.css';
import About from './Components/About';
import Design from './Components/Design';
import MyNav from './Components/MyNav';
import Project from './Components/Project';
import Quality from './Components/Quality';
import Cards from './Components/Cards';
import Footer from './Components/Footer';
import Home from './Components/Home';

function App() {
  return (
    <>
      <Home/>
      <About/>
      <Quality/>
      <Project/>
    </>
  );
}

export default App;
